import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slideImages = [
    {
      src: 'https://i.postimg.cc/9XRXdCH3/book-distribution-cover.jpg',
      title: 'Book Distribution',
      description: 'Spreading Krishna consciousness through Srila Prabhupada\'s books'
    },
    {
      src: 'https://i.postimg.cc/s2HyW0nD/class-cover.jpg',
      title: 'Spiritual Classes',
      description: 'Teaching Bhagavad Gita and Srimad Bhagavatam'
    },
    {
      src: 'https://i.postimg.cc/NFP0xNQX/IMG-20250608-WA0046.jpg',
      title: 'Book Distribution',
      description: 'Sharing the timeless wisdom of the Bhagavad Gita on a bustling city street'
    },
    {
      src: 'https://i.postimg.cc/Vs751NXN/IMG-20250726-WA0100.jpg',
      title: 'Book Distribution',
      description: 'A joyful group celebrates a successful day of book distribution with a happy recipient'
    },
    {
      src: 'https://i.postimg.cc/jdm5wkg0/IMG-20250802-WA0125.jpg',
      title: 'Book Distribution',
      description: 'Inspiring the next generation by sharing spiritual stories with a young reader at a community festival'
    },
    {
      src: 'https://i.postimg.cc/fRdbxjp3/IMG-20250802-WA0126.jpg',
      title: 'Book Distribution',
      description: 'Engaging a young couple in a thoughtful spiritual conversation in a public park'
    },
    {
      src: 'https://i.postimg.cc/3JdNwHZF/IMG-20250807-WA0005.jpg',
      title: 'Book Distribution',
      description: 'Book Distribution at a vibrant outdoor market'
    },
    {
      src: 'https://i.postimg.cc/jjQd1qst/IMG-20250807-WA0009.jpg',
      title: 'Book Distribution',
      description: 'Devotees sharing smiles and making friendly connections with visitors at a community festival stall'
    },
    {
      src: 'https://i.postimg.cc/jjrSvnYM/IMG-20250807-WA0011.jpg',
      title: 'Nagar Sankirtan',
      description: 'A devotee leads a heartfelt public harinaam, sharing sacred sounds during an outreach event.'
    },
    {
      src: 'https://i.postimg.cc/3R8JQMRp/IMG-20250807-WA0026.jpg',
      title: 'Book Distribution',
      description: 'Combining the joyous sounds of Nagar Sankirtan with a book stall to share spiritual knowledge.'
    },
    {
      src: 'https://i.postimg.cc/wvwx6Wyr/Screenshot-2025-08-09-at-3-49-26-PM.png',
      title: 'Book Distribution',
      description: 'Distributing the Bhagavad Gita and Srila Prabhupada’s books on Newbury Street'
    },
    {
      src: 'https://i.postimg.cc/MKTQMpRn/camp-1.jpg',
      title: 'Spiritual Camp',
      description: 'Devotees engage in a vibrant dancing kirtan along the seashore in a spiritual retreat'
    },
    {
      src: 'https://i.postimg.cc/mrxz53n9/camp-2.jpg',
      title: 'Spiritual Camp',
      description: 'A joyful and uplifting spiritual youth camp'
    },
    {
      src: 'https://i.postimg.cc/g2LLstgd/camp-4.jpg',
      title: 'Spiritual Camp',
      description: 'Devotees going on a spiritual retreat'
    },
    {
      src: 'https://i.postimg.cc/9FnqGHtJ/harinaam.jpg',
      title: 'Spiritual Camp',
      description: 'Devotees joyfully participate in a Harinaam procession in a spiritual youth camp'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slideImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slideImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slideImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slideImages.length) % slideImages.length);
  };

  return (
    <div className="hero-section">
      <div 
        className="hero-background"
        style={{
          backgroundImage: 'url(https://i.postimg.cc/1tgSrcT0/prabhupada-cover.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="hero-overlay">
          <div className="hero-content">
            <h1 className="hero-title">
              The Greatest Service to Humanity is to 
              <span className="highlight"> Awaken Krishna Consciousness</span>
            </h1>
            <p className="hero-subtitle">
              Join us in spreading the transcendental knowledge of the Vedas
            </p>
          </div>
          
          {/* Glass-morphism slideshow panel at bottom */}
          <div className="slideshow-panel">
            <div className="slideshow-content">
              <Button
                variant="ghost"
                size="sm"
                onClick={prevSlide}
                className="slide-nav-btn slide-nav-left"
              >
                <ChevronLeft className="w-5 h-5" />
              </Button>
              
              <div className="slide-container">
                <img
                  src={slideImages[currentSlide].src}
                  alt={slideImages[currentSlide].title}
                  className="slide-image"
                />
                <div className="slide-text">
                  <h3 className="slide-title">{slideImages[currentSlide].title}</h3>
                  <p className="slide-description">{slideImages[currentSlide].description}</p>
                </div>
              </div>
              
              <Button
                variant="ghost"
                size="sm"
                onClick={nextSlide}
                className="slide-nav-btn slide-nav-right"
              >
                <ChevronRight className="w-5 h-5" />
              </Button>
              
              <div className="slide-nav-buttons">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={prevSlide}
                  className="slide-nav-btn"
                >
                  <ChevronLeft className="w-5 h-5" />
                </Button>
                
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={nextSlide}
                  className="slide-nav-btn"
                >
                  <ChevronRight className="w-5 h-5" />
                </Button>
              </div>
            </div>
            
            <div className="slide-indicators">
              {slideImages.map((_, index) => (
                <button
                  key={index}
                  className={`indicator ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;